import { ChangeDetectionStrategy, Component, OnInit, Renderer2 } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'

import { AppService, AuthService, CartStorageService, SetColorsService, ShoppingCartService } from 'core'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnInit {
  idIsDetected = false
  pageIsNotAvailable = false
  isOwner = false
  showCartPopup = false
  isDividingLine = false

  currentRoute: string

  favIcon: HTMLLinkElement = document.querySelector('#prodPageFavicon')

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private titleService: Title,
    private readonly authService: AuthService,
    private appService: AppService,
    private readonly cartStorageService: CartStorageService,
    private setColorsService: SetColorsService,
    private readonly shoppingCartService: ShoppingCartService
  ) {
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.currentRoute = event.url

      if (this.currentRoute === '/' || this.currentRoute.includes('/?devBeatmakerId')) {
        this.isDividingLine = false
        return
      }
      if (this.currentRoute.length > 1) {
        this.isDividingLine = true
      }
    })
  }

  ngOnInit() {
    this.authService.me()

    // 🧺 Синхронизация корзины
    this.authService.user.subscribe(user => {
      if (user.isAuth) {
        this.cartStorageService.synchronizeLocalAndServerShoppingCarts(
          () => this.shoppingCartService.getShoppingCart(),
          beats => this.shoppingCartService.updateShoppingCart(beats)
        )
      }
    })

    this.getDetectedId()
  }

  getDetectedId() {
    this.appService.beatMakerDataSubject.subscribe(data => {
      if (data) {
        if (data?.beatmakerId) {
          this.idIsDetected = true

          // color settings
          if (data?.colors) {
            this.getStylesFromServer(data.colors)
          }

          this.setNewDocumentTitle(data.beatmakerName)
          this.setFavicon(data.faviconUrl)

          /* Color settings icon */
          if (data.beatmakerId === data.currentUserId) {
            this.isOwner = true
          }
        } else {
          this.pageIsNotAvailable = true
        }
      }
    })
  }

  setNewDocumentTitle(title: string) {
    this.titleService.setTitle(title)
  }

  setFavicon(favicon: string) {
    this.favIcon.href = favicon
  }

  closeCartPopup() {
    this.showCartPopup = false
    this.renderer.removeClass(document.body, 'modal-open')
  }

  getStylesFromServer(colors: string) {
    const parseColors = JSON.parse(colors)
    if (Array.isArray(colors) || parseColors === null) {
      // Старый формат данных (см.interface IBeatmakerData)
      // Т.к. стили название стилей изменились, то сохранить прежние цвета не получится
      // Поэтому грузим битмейкеру тему по умолчанию (отправляю запрос на сервер чтобы пересохранить новые данные в новом формате)
      this.setColorsService.sendSettings('PROD-PAGE', 'dark-red')
    } else {
      // Новый формат данных (см.interface IBeatmakerData)
      const styles = parseColors.styles
      const theme = parseColors.theme
      if (styles) {
        this.setColorsService.transformStylesFromServer(styles)
        this.setColorsService.setTheme(theme)
      }
      this.setColorsService.refreshStyleTag(theme)
    }
  }
}
